import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetShowWelcomeScreenParams {
  showWelcomeScreen: boolean;
}

export class SetShowWelcomeScreenRequest extends Request<SetShowWelcomeScreenParams, IResult> {
  constructor(params: SetShowWelcomeScreenParams) {
    super('setShowWelcomeScreen', params);
  }
}
